<template>
  <div class="reviewTaskManage">
    <headTop :data="'/index'" v-if="$route.query.b == 1 || $route.query.b == 2"></headTop>
    <headTop :data="'/legislateKnowledgeBase'" v-if="$route.query.b == 3"></headTop>
    <headTop
      :data="'/recordReview/reviewTaskManage'"
      v-if="$route.query.b == 4"
    ></headTop>
    <el-header class="breadCrumbs">
      <el-breadcrumb separator="/" v-if="$route.query.b == 1 || $route.query.b == 2">
        <i class="iconfont icon-home fl mr10"></i>
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.b == 1">知识详情查看</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.b == 2">刊物详情查看</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator="/" v-if="$route.query.b == 3">
        <i class="iconfont icon-home fl mr10"></i>
        <el-breadcrumb-item :to="{ path: '/legislateKnowledgeBase' }"
          >立法知识库</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识详情查看</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator="/" v-if="$route.query.b == 4">
        <i class="iconfont icon-home fl mr10"></i>
        <el-breadcrumb-item>智能审查</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'recordReview/reviewTaskManage' }"
          >审查任务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: 'recordReview/recordReview' }"
          >智能审查详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识详情查看</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-container>
      <!-- <headTop :data="'/recordReview/reviewTaskManage'"></headTop> -->
      <div class="iframeBox por">
        <iframe
          :src="url"
          frameborder="0"
          width="100%"
          scrolling="auto"
          id="iframe"
        ></iframe>
      </div>
    </el-container>
    <!-- <el-footer style="position: fixed; width: 100%; bottom: 0">
      <foot></foot>
    </el-footer> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "", //详情页网址
    };
  },
  created() {
    this.url = this.$route.query.url;
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    let query = this.$route.query;
    function changeMobsfIframe() {
      const mobsf = document.getElementById("iframe");
      //   const deviceWidth = document.body.clientWidth;
      const deviceHeight = document.body.clientHeight;
      const screenHeight = window.screen.height;
      //   mobsf.style.width = (Number(deviceWidth)-120) + 'px'; //数字是页面布局宽度差值
      // 根据不同跳转页面隐藏原网站头部banner
      if (query.type == 2) {
        // 数字图书馆
        document.getElementById("iframe").style.marginTop = "-270px";
        // mobsf.style.height = Number(deviceHeight) + 157 + "px"; //数字是页面布局高度差
        mobsf.style.height = screenHeight - 0 + "px";
      } else if (query.type == 3) {
        // 政报
        document.getElementById("iframe").style.marginTop = "-320px";
        // mobsf.style.height = Number(deviceHeight) + 300 + "px"; //数字是页面布局高度差
        mobsf.style.height = screenHeight + 60 + "px";
      } else {
        // document.getElementById("iframe").style.marginTop = "-96px";
        // // mobsf.style.height = Number(deviceHeight) + 800 + "px"; //数字是页面布局高度差
        // mobsf.style.height = screenHeight - 180 + "px";

        document.getElementById("iframe").style.marginTop = "-270px";
        // mobsf.style.height = Number(deviceHeight) + 157 + "px"; //数字是页面布局高度差
        mobsf.style.height = screenHeight - 0 + "px";
      }
    }

    changeMobsfIframe();

    window.onresize = function () {
      changeMobsfIframe();
    };
  },
  methods: {
    //切换导航
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/mixin.scss"; //定义方法
.reviewTaskManage {
  background: $bodyColor;
}
// 头部
.header {
  @include theme();
}
.header /deep/ {
  height: 84px !important;
  line-height: 84px;
  .title {
    // @include fontSize($fz24, $num);
    font-size: 36px;
    color: $cfff;
  }
  .welcome {
    @include fontSize($fz12, $num);
    color: $cd0dcfb;
  }
  // 导航
  & > .el-menu {
    background: transparent !important;
    float: left;
    .iconfont {
      position: absolute;
      bottom: 16px;
      left: 50%;
      margin-left: -6px;
      @include fontSize($fz12, $num);
      color: $c7ca1fa;
      line-height: 0px;
      display: none;
    }
    .el-submenu .el-menu-item {
      border-bottom: 1px dashed #d4d2d2;
      &:last-child {
        border: none;
      }
    }
    .el-menu--horizontal {
      left: 4px !important;
      .el-menu-item {
        line-height: 36px;
        height: 36px;
      }
    }
  }
  .el-menu-demo1 {
    margin-left: 6%;
  }
  & > .el-menu > .el-menu-item,
  .el-submenu__title {
    @include fontSize($fz18, $num);
    color: $c7ca1fa;
    position: relative;
  }
  .el-submenu {
    position: relative;
  }
  .el-menu.el-menu--horizontal,
  .el-menu--horizontal > .el-menu-item {
    border: none;
  }
  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 84px;
    line-height: 84px;
    color: $c7ca1fa;
    border-bottom: none;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    position: relative;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background: transparent;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
    color: $cfff;
  }
  .el-submenu.is-active {
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  //更多操作
  .el-menu-demo2 {
    float: right;
    margin-right: 10%;
    .iconfont {
      display: block;
      @include fontSize($fz30, $num);
      color: $cfff;
      bottom: 40px;
    }
  }
}

//侧边
.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
  overflow: inherit;
  min-height: calc(100vh - 210px);
  width: 280px;
  align-items: stretch;
  position: relative;
}
//中间内容
.el-main {
  background: transparent;
  color: #333;
  text-align: center;
  min-height: calc(100vh - 210px);
  h2 {
    @include fontSize($fz16, $num);
  }
  p {
    @include fontSize($fz12, $num);
  }
}
// 底部
.el-footer {
  height: auto !important;
  @include theme();
}

.iframeBox /deep/ {
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #fff;
  #iframe {
    // margin-top: -96px;
    iframe {
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
